var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email-distributions"},[_c('r-title',[_vm._v(_vm._s(_vm.title))]),_c(`email-distributions-${_vm.mode}`,{tag:"component",on:{"mode":_vm.changeMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }